import { render, staticRenderFns } from "./LocationField.vue?vue&type=template&id=0454c81a&scoped=true"
import script from "./LocationField.vue?vue&type=script&lang=js"
export * from "./LocationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0454c81a",
  null
  
)

export default component.exports